import { BehaviorSubject } from "rxjs";

export type Role =
  | 'SuperUser'
  | 'GeneralManager'
  | 'OfficeManager'
  | 'ProductionManager'
  | 'ProductionAdmin'
  | 'FieldSuperintendent'
  | 'RegionalManager'
  | 'CentralizedSupport'
  | 'VPOfOperations'
  | 'CFO'
  | 'FieldSupport'
  | 'EditPayments'
  | 'AccountingPostPayment';

export const GROUP_ID_TO_ROLE: Record<string, Role> = {
  '4c885c05-73f1-4cab-b582-c9bd16edd451': 'SuperUser',
  'e795e97c-9693-45b8-b970-ec8c7d6002d2': 'GeneralManager',
  'efd73824-0320-42cc-aa6b-2f4ec2c7fe2b': 'OfficeManager',
  '84aa4935-17b3-4e65-88f2-f6c016b011f7': 'ProductionManager',
  'ba30e6b6-7f20-468a-83ab-7b9aae872d74': 'ProductionAdmin',
  'b05aaeac-a66d-46bb-af64-e4ff7de9ab8e': 'FieldSuperintendent',
  '5fee38c8-9e2b-4d49-9350-4a5b843f4aad': 'CentralizedSupport',
  '30f9463b-2bfb-4cb9-839d-fbb34de4d0a4': 'RegionalManager',
  'b7350296-680f-47e7-829c-06f92cc8f171': 'VPOfOperations',
  'dc1cbb3f-bb8f-4fd0-81f6-c7a6b837a8db': 'CFO',
  '6529a5c0-bba6-4256-9a05-446ef75090a8': 'FieldSupport',
  '45bd07a5-b3db-427c-86c3-6d7d79b2305f': 'EditPayments',
  '28ed1de7-a5db-4534-82d6-0034e66ae8b8': 'AccountingPostPayment',
};

export const initialUserRoles: Record<Role, boolean> = {
  SuperUser: false,
  GeneralManager: false,
  OfficeManager: false,
  ProductionManager: false,
  ProductionAdmin: false,
  FieldSuperintendent: false,
  RegionalManager: false,
  CentralizedSupport: false,
  VPOfOperations: false,
  CFO: false,
  FieldSupport: false,
  EditPayments: false,
  AccountingPostPayment: false,
};

export const CALENDAR_ROLES: Role[] = [
  'GeneralManager',
  'OfficeManager',
  'ProductionManager',
  'ProductionAdmin',
  'FieldSuperintendent',
  'CentralizedSupport',
  'RegionalManager',
  'SuperUser',
  'VPOfOperations',
  'CFO',
  'FieldSupport',
];

export const hasCalendarAccess = (): boolean => {
  const roles = getUserRoles();
  return CALENDAR_ROLES.some(role => roles[role]);
};

export const userRoles$ = new BehaviorSubject<Record<Role, boolean>>(initialUserRoles);

export const observeUserRoles$ = () => {
  return userRoles$.asObservable();
};

export const getUserRoles = () => {
  return userRoles$.getValue();
};

export const setUserRole = (role: Role, value: boolean) => {
  const currentRoles = userRoles$.getValue();
  userRoles$.next({ ...currentRoles, [role]: value });
};

export const resetUserRoles = () => {
  userRoles$.next(initialUserRoles);
};

export const setUserRoles = (roles: Role[]) => {
  const next = { ...initialUserRoles };
  for (const role of roles) {
    next[role] = true;
  }
  userRoles$.next(next);
};
